import PageTemplate from "../components/PageTemplate";
import Content from "../components/Content"
import PageFade from "../motions/PageFade";
import { useEffect } from 'react';

function Registry() {
    console.log("Registry rendered");

    useEffect(() => {
        console.log("Registry mounted");

        return () => {
            console.log("Registry unmounted");
        };
    }, []);

    return (
        <PageFade>
            <PageTemplate title="Registry" textColor="text-rose">
                <Content small={true}>
                    <div className="space-y-6">
                        <p>
                            Your presence is the greatest gift! But if you’d like to give, we’ve
                            set up a cash registry through WithJoy.
                        </p>
                        <p>
                            Click below to explore contribution options and support our next
                            chapter together! We will also be accepting gifts on-site on the
                            wedding day.
                        </p>
                    </div>
                    <div className="max-w-sm mx-auto bg-white border border-gray-200 shadow-sm m-10 hover:cursor-pointer transition transform hover:-translate-y-1">
                        <a
                            href="https://withjoy.com/thuyan-and-jerry/registry"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src="/assets/images/registry/registry-photo.jpg"
                                alt="Thuyan and Jerry"
                                className="w-full h-64 object-cover"
                            />
                            <div className="p-6 text-center space-y-4">
                                <h2 className="text-2xl font-semibold text-gray-800">Thuyan & Jerry</h2>
                                <p className="text-gray-600">
                                    Welcome to the wedding registry for Thuyan and Jerry!
                                </p>
                                <img
                                    src="https://mma.prnewswire.com/media/1606595/Joy_Logo.jpg?w=20"
                                    alt="WithJoy"
                                    className="mx-auto"
                                />
                            </div>
                        </a>
                    </div>
                </Content>
            </PageTemplate>
        </PageFade>
    );
}

export default Registry;
